import React from 'react'
import CheckoutLayout from '../../../checkout/CheckoutPage/CheckoutLayout'
import { useSalesChannel } from '../../../../context/SalesChannelContext';
import { OrderSuccessProps } from '../../Default/OrderSuccess';
import { BsArrowLeft, BsCheckCircle } from 'react-icons/bs';
import CartDisplay from '../../../ecommerce/CartDisplay';
import { formatPrice } from '../../../../utils/currency';
import { Link } from 'gatsby-link';

export default function OrderSuccess({ order, loading, salesChannel }: OrderSuccessProps) {
    return (
        <CheckoutLayout seo={{ title: `Order ${order?.number}` }} cart={undefined} hideNav={true} containerClass='max-w-screen-lg' showCouponCode={false} >
            <section className="py-3 px-8 md:py-5">
                {!loading && order ? (

                    <div className="flex flex-wrap justify-between -mx-3">

                        <div className='px-3 w-full'>
                            <div className='mb-4'>
                                <Link to="/">
                                    <div className='flex items-center text-primary text-sm underline'>
                                        <BsArrowLeft className='mr-2' />
                                        <span>
                                            Back to Website
                                        </span>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        <div className="px-3 w-full mb-5 md:w-auto md:flex-1 md:pr-14">

                            {order.status == "paymentFailed" ? (
                                <div className='mb-3'>
                                    <PaymentFailedMessage />
                                </div>
                            ) : (
                                <>
                                    <h2 className="text-xl md:text-3xl">
                                        Thank you, {order.customer.firstName}
                                    </h2>
                                    <h1 className="text-3xl md:text-5xl">
                                        Order Successful
                                    </h1>
                                    <p className='py-6'>
                                        An email confirmation has been sent to {order.customer.email}.
                                    </p>
                                    <div className=''>
                                        <h3 className='text-lg mb-2'>
                                            Your billing address is:
                                        </h3>
                                        <p>
                                            {order.billingAddress.firstName} {order.billingAddress.lastName}
                                            <br />
                                            {order.billingAddress.line1}
                                            <br />
                                            {order.billingAddress.line2 && (
                                                <>
                                                    {order.billingAddress.line2}
                                                    <br />
                                                </>
                                            )}
                                            {order.billingAddress.postCode}
                                            <br />
                                            {order.billingAddress.city}
                                            <br />
                                            {order.billingAddress.countryCode}
                                        </p>
                                    </div>
                                    {order.isShipped && (
                                        <div className='mt-4'>
                                            <h3 className='text-lg mb-2'>
                                                This order will be shipped to:
                                            </h3>
                                            <p>
                                                {order.shippingAddress[0].firstName} {order.shippingAddress[0].lastName}
                                                <br />
                                                {order.shippingAddress[0].line1}
                                                <br />
                                                {order.shippingAddress[0].line2 && (
                                                    <>
                                                        {order.shippingAddress[0].line2}
                                                        <br />
                                                    </>
                                                )}
                                                {order.shippingAddress[0].city}
                                                <br />
                                                {order.shippingAddress[0].postCode}
                                                <br />
                                                {order.shippingAddress[0].countryCode}
                                            </p>
                                        </div>
                                    )}
                                    <div className='mt-6'>
                                        <div className='bg-secondary text-white rounded p-5'>
                                            <h3 className='mb-2'>Got Questions?</h3>
                                            <p>
                                                Call us on <a className='font-bold underline' href={`tel:${salesChannel.phone}`}>{salesChannel.phone}</a>{" "}
                                                or email us at <a className='font-bold underline' href={`mailto:${salesChannel.email}`}>{salesChannel.email}</a>{" "}
                                                and our Customer service team will be happy to help.
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>

                        <div className='px-3 w-full md:w-[350px]'>
                            <div className='border rounded p-5'>
                                <h2 className='mb-4'>
                                    Order Summary
                                </h2>
                                <table className='w-full'>
                                    <thead>
                                        <tr>
                                            <th className='text-left px-3 py-2'>Product</th>
                                            <th className='text-right px-3 py-2'>Qty</th>
                                            <th className='text-right px-3 py-2'>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {order.orderItems.map((item, index) => (
                                            <tr key={index}>
                                                <td className='border-t px-3 py-2'>
                                                    {item.name}
                                                </td>
                                                <td className='border-t px-3 py-2 text-right'>
                                                    {item.quantity}
                                                </td>
                                                <td className='border-t px-3 py-2 text-right'>
                                                    {formatPrice(item.totalAmount)}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td className='border-t-4'></td>
                                            <td className='border-t-4 px-3 py-2'>
                                                Subtotal
                                            </td>
                                            <td className='border-t-4 px-3 py-2 text-right'>
                                                {formatPrice(order.subTotalAmount)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td className='border-t px-3 py-2'>
                                                Shipping
                                            </td>
                                            <td className='border-t px-3 py-2 text-right'>
                                                {formatPrice(order.shippingAmount)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td className='border-t px-3 py-2'>
                                                Total
                                            </td>
                                            <td className='border-t px-3 py-2 text-right'>
                                                {formatPrice(order.totalAmount)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                ) : null}
            </section>
        </CheckoutLayout >
    )
}

function PaymentFailedMessage() {
    const salesChannel = useSalesChannel();
    return (
        <>
            <h2 className="text-4xl uppercase">
                Payment Failed
            </h2>
            <h3 className="text-2xl mt-4 mb-2">
                Having trouble placing an order?
            </h3>
            <div className='mb-3'>
                You can call us on
                {" "}
                <a className='font-bold underline' href={`tel:${salesChannel?.phone}`}>{salesChannel?.phone}</a>
                {" "}
                9AM - 5PM, Monday - Friday or drop us an email on
                {" "}
                <a className='font-bold underline' href={`mailto:${salesChannel?.email}`}>{salesChannel?.email}</a>
                {" "}
                and our Customer service team will be happy to help.
            </div>
        </>
    )
}
